import { render, staticRenderFns } from "./eod-events-sidebar.vue?vue&type=template&id=a542c356"
import script from "./eod-events-sidebar.vue?vue&type=script&lang=js"
export * from "./eod-events-sidebar.vue?vue&type=script&lang=js"
import style0 from "./eod-events-sidebar.vue?vue&type=style&index=0&id=a542c356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports